import { Component } from '@angular/core';
@Component({
    selector: 'app-program-page',
    template: 'test',
    styleUrls: [],
})
export class ProgramPageTestComponent {
}